import { RouteConfig } from 'vue-router'

import InstagramInstantwinApplicantListPage from './pages/InstagramInstantwinApplicantListPage.vue'

export const instagramInstantwinApplicantList: RouteConfig = {
  path: '/instagram_instantwins/:campaignId/prizes/:prizeId/applicants',
  name: 'instagram_instantwin_applicants',
  component: InstagramInstantwinApplicantListPage,
  props: route => ({
    campaignId: route.params.campaignId ? Number(route.params.campaignId) : null,
    prizeId: route.params.prizeId ? Number(route.params.prizeId) : null
  })
}
